export function ellipsisText(str, length) {
    let res = "";
    let len = calcLength(str);
    if (len > length) {
        //获取显示的字符串
        let temp = length-1;
        let strArr = str.split("");
        while (temp > 0 && strArr.length) {
            let c = strArr.shift();
            temp -= calcLength(c);
            res += c;
        }
        res = res + '...';
    } else {
        return str;
    }
    return res;
}

//计算字符串长度
function calcLength(str) {
    let len = 0;
    if (!str || !str.length) return 0;
    for(let c = 0; c<str.length; c++) {
        if (
            //中文
            /[\u4E00-\u9FA5\uF900-\uFA2D]/.test(str[c]) || 
            //特殊字符
            /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/.test(str[c]) || 
            ("A" <= c && "Z" >= c)
        ) {
            len += 2;
        } else {
            len++;
        }
    }
    return len;
}